var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DocumentDetail',{attrs:{"title":"Bevételek","resource-type":"INCOME"}})
}
var staticRenderFns = []

export { render, staticRenderFns }